import { format } from 'date-fns';
import { NestedHome } from '@habity/types';
import { CommonEstateBid } from '@habity/types/vitec/common/commonEstateBid';
import { formatCurrency } from '@habity/utils';
import { getActiveBids } from '@habity/services';
import { TableDataItem } from '~/components/ui/tables/Table';

/**
 * Format bidding history data for display in a table
 */
export const getBiddingHistoryData = (home: NestedHome): TableDataItem[] => {
  const data: TableDataItem[] = [];

  const activeBids = getActiveBids(home);
  activeBids?.map((bid: CommonEstateBid) => {
    const {
      alias,
      amount,
      dateAndTime,
      status,
    } = bid || {};
    data.push({
      label: formatCurrency(amount),
      value: `Budgivare ${alias}${
        status !== 'DeltarBudgivning' ? ' (stannat)' : ''
      }`,
      comment: dateAndTime
        ? `${format(new Date(dateAndTime), 'yyyy-MM-dd HH:mm')}`
        : '',
    });
  });

  return data;
};
